/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'overview': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M28.8 3.3h-4.9V2.2c0-.6-.4-1-1-1H11.1c-.6 0-1 .4-1 1v1.1H5.2c-.6 0-1 .4-1 1v25.3c0 1.7 1.3 3.1 3 3.1h19.6c1.7 0 3-1.4 3-3.1V4.3c0-.5-.5-1-1-1zm-16.7-.1h9.8V7.5h-9.8V3.2zm15.7 26.5c0 .6-.4 1.1-1 1.1H7.2c-.5 0-1-.5-1-1.1V5.3h3.9v2.2c0 1.1.9 2 2 2h9.8c1.1 0 2-.9 2-2V5.3h3.9v24.4z"/><path pid="1" d="M20.2 16.2L15 21.8l-1.2-1.3c-.4-.4-1-.4-1.4-.1s-.4 1-.1 1.4l2 2.1c.4.4 1.1.4 1.5 0l5.9-6.3c.4-.4.4-1-.1-1.4-.4-.4-1-.4-1.4 0z"/>'
  }
})
